import { SAVE_CLIENTS, EDIT_CLIENTS, SEARCH_CLIENTS, REFRESH_CLIENTS } from '../actions';
import { baseUrl } from '../utils/constants';

const clientReducer = (state, action) => {
  if (action.type === SAVE_CLIENTS) {
    const { client } = action.payload;

    const dateToday = new Date();
    console.log('done saving');
    return { ...state, client };
    // return { ...state, cart: [...state.cart, client] }
  }
  if (action.type === EDIT_CLIENTS) {
    const tempCart = state.cart.filter((item) => item.id !== action.payload);
    return { ...state, cart: tempCart };
  }
  if (action.type === SEARCH_CLIENTS) {
    return { ...state, cart: [] };
  }
  if (action.type === REFRESH_CLIENTS) {
    const { clientRefId, setCurrentClient, setClientAffordability, setClientBankingDetails } =
      action.payload;
    console.log('Pressed enter to view client', clientRefId);

    if (clientRefId > 0) {
      fetch(`${baseUrl}/api/client/getPersonalDetailsByClient?clientRefId=${clientRefId}`)
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('returned personal', result);
            setCurrentClient(result.result);
          },
          (error) => {
            alert('failed');
          }
        );

      // fetch(`${baseUrl}/api/client/getAffordabilityDetailsByClient?clientRefId=${clientRefId}`)
      //   .then((res) => res.json())
      //   .then(
      //     (afford) => {
      //       console.log('returned affordability', afford);
      //       setClientAffordability(afford.result);
      //     },
      //     (error) => {
      //       alert('failed');
      //     }
      //   );

      // fetch(`${baseUrl}/api/client/getBankDetailsByClient?clientRefId=${clientRefId}`)
      //   .then((res) => res.json())
      //   .then(
      //     (bank) => {
      //       console.log('returned banking detail', bank);
      //       setClientBankingDetails(bank.result);
      //     },
      //     (error) => {
      //       alert('failed');
      //     }
      //   );
    }
    return { ...state };
  }

  // const getDocumentDetailsByClient = async (clientRefId) => {
  //   const response = await fetch(
  //     `${baseUrl}/api/client/getdocumentsbyclient?clientRefId=${clientRefId}`
  //   );
  //   const data = await response.json();
  //   state.setClientDocList(data.result);
  //   console.log('documents data at Context', data.result);
  // };

  throw new Error(`No Matching "${action.type}" - action type`);
};

export default clientReducer;
